export const FETCH_STATUS: {
	inProgress: 'IN_PROGRESS_FETCH_STATUS';
	error: 'ERROR_FETCH_STATUS';
	success: 'SUCCESS';
} = {
	inProgress: 'IN_PROGRESS_FETCH_STATUS',
	error: 'ERROR_FETCH_STATUS',
	success: 'SUCCESS',
};
export type FetchStatus = (typeof FETCH_STATUS)[keyof typeof FETCH_STATUS];
